import { createActionGroup, props } from '@ngrx/store';

import { MeetingPrepCtaId } from './meeting-prep-panel.model';

export const MeetingPrepPanelActions = createActionGroup({
  source: 'Meeting Prep Panel',
  events: {
    'Maz Ctas Shown': props<{ teamId: string; isOnMyNinety: boolean }>(),
    'Maz Cta Clicked': props<{ ctaId: MeetingPrepCtaId; teamId: string; isOnMyNinety: boolean }>(),
  },
});
